import React, { useEffect, useRef, useState } from 'react';

import { EASE_CUBIC } from '@pkg/components/Sections/Profile/StyledThemeProvider/themes/default';

import { type ActivityPanelVariants } from '../ActivityList.types';

import { ActiveLine, FilterButton, Wrapper } from './styles';

// Offers is missing in the array but we don't support bids yet
const activityFilterTabs = ['All', 'Buys', 'Sales', 'Listings', 'Mints'] as const;
const activityFilterTabsWishlist = ['All', 'Floor Price', 'Sales', 'Listings'] as const;

const allTabs = [...activityFilterTabs, ...activityFilterTabsWishlist, 'Offers', 'Transfers'] as const;

export type ActivityFilterTabsType = (typeof allTabs)[number];

interface ActivityFiltersProps {
    activeTab: string;
    variant?: ActivityPanelVariants;
    setActiveTab: (value: ActivityFilterTabsType) => void;
}

export const ActivityFilters = ({ activeTab, setActiveTab, variant }: ActivityFiltersProps) => {
    const wrapperRef = useRef<HTMLDivElement>(null);
    const activeTabRef = useRef<HTMLDivElement>(null);

    const [activeLine, setActiveLine] = useState<{ width: number; x: number }>({
        width: 18,
        x: 0,
    });

    const tabs = variant === 'wishlist' ? activityFilterTabsWishlist : activityFilterTabs;

    useEffect(() => {
        const node = activeTabRef.current;
        const position = node?.getBoundingClientRect();
        const parentPosition = wrapperRef.current?.getBoundingClientRect();
        if (position && parentPosition) {
            setTimeout(
                () =>
                    setActiveLine({
                        width: position.width,
                        x: position.x - parentPosition.x,
                    }),
                100,
            );
        }
    }, [activeTab]);

    return (
        <Wrapper ref={wrapperRef}>
            {tabs.map((type) => {
                return (
                    <FilterButton
                        key={`tab-${type}`}
                        $isActive={activeTab === type}
                        ref={activeTab === type ? activeTabRef : undefined}
                        onClick={() => setActiveTab(type)}
                    >
                        {type}
                    </FilterButton>
                );
            })}
            <ActiveLine animate={activeLine} transition={{ duration: 0.6, ease: EASE_CUBIC }} />
        </Wrapper>
    );
};
